import {call, put, select, takeLatest} from 'redux-saga/effects'

import {
  DISPLAY_PRODUCT_DETAILS,
  GET_RECOMMENDED_ITEMS,
  displayProduct,
  getRecommendedItemsFailure,
  getRecommendedItemsPending,
  getRecommendedItemsSuccess,
  resetToInitialState,
} from '../actions/product'

import {isGoodResponse} from '../api/statusCodes'
import {clearReviews} from '../actions/reviews'
import {closeSoldOutModal, closeZoomModal, zoomIn} from '../actions/productDetailPage'

import * as api from '../api/api'
import * as pdpSelectors from '../store/productDetailPage'

// Get Recommended Items
// ----------------------------------------------------------------------------

export function* getRecommendedItemsWorker() {
  yield put(getRecommendedItemsPending())

  try {
    const productId = yield select(pdpSelectors.productId)
    const {
      json: {results},
      status,
    } = yield call(api.getRecommendedItems, productId)
    if (isGoodResponse(status)) {
      yield put(getRecommendedItemsSuccess(results))
    } else {
      throw new Error(`Could not get recommended items: ${status}`)
    }
  } catch (e) {
    console.error(e.message)
    yield put(getRecommendedItemsFailure(e))
  }
}

export function* getRecommendedItemsSaga() {
  yield takeLatest(GET_RECOMMENDED_ITEMS, getRecommendedItemsWorker)
}

// Display Product Details
// ----------------------------------------------------------------------------

export function* displayProductDetailsWorker({payload: {slug, origin}}) {
  yield put(resetToInitialState())
  yield put(displayProduct(slug, origin))
  yield put(clearReviews())
  yield put(closeSoldOutModal())
  yield put(closeZoomModal())
  yield put(zoomIn())
}

export function* displayProductDetailsSaga() {
  yield takeLatest(DISPLAY_PRODUCT_DETAILS, displayProductDetailsWorker)
}
